export default {
  token: state => state.token,
  user: state => state.user,
};
